import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ListFormat } from 'src/app/_objects/report-template';

@Component({
    selector: 'app-hotspot-observations-dialog',
    templateUrl: './list-dialog.component.html',
    styleUrls: ['./list-dialog.component.scss'],
    standalone: false
})
export class ListDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  public isEdit = false;
  public readonly separatorKeysCodes: number[] = [ENTER];
  public observationList: string[] = [];
  public readonly valueMaxLength = 30;
  public nameControl = new UntypedFormControl(null, [Validators.required, Validators.maxLength(this.valueMaxLength)]);
  public listControl = new UntypedFormControl('', [Validators.required]);
  public idControl = new UntypedFormControl('');
  
  ngOnInit(): void {
    this.isEdit = this.data.isEdit;
    if(this.isEdit) {
      this.nameControl.setValue(this.data.formatItem.name);
      this.idControl.setValue(this.data.formatItem.id);
      this.observationList = this.data.formatItem.listData;
    }
  }

  add(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    // Add our observation
    if ((value || '').trim()) {
      this.observationList.push(value.trim());
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeList(name) {
    const index = this.observationList.indexOf(name);
    if (index >= 0) {
      this.observationList.splice(index, 1);
    }
  }

  submit() {
    const item: ListFormat = new ListFormat();
    item.name = this.nameControl.value;
    item.id = this.idControl.value;
    item.listData = this.observationList;
    this.dialogRef.close(item);
  }
 }
